import { Modal } from "react-bootstrap";
import { Row } from "rsuite";

export const ModalVideo = ({
  modal,
  setModal,
}: {
  modal: boolean;
  setModal: any;
}) => {
  return (
    <Modal
      show={modal}
      onHide={() => setModal(false)}
      size="xl"
      centered
      scrollable
    >
      <Modal.Header
        className="border-bottom-0 pb-0 text-center"
        closeButton
      ></Modal.Header>
      <Modal.Body className="pt-0">
        <Row className="d-flex justify-content-around my-5">
          <div>
            <div className="text-center text-primary">
              <h1>Sistema de Búsqueda de Sentencias y Jurisprudencia</h1>
            </div>
          </div>
        </Row>
        <Row className="d-flex justify-content-center">
          <video width="80%" controls>
            <source
              src=""
              type="video/mp4"
            />
            Tu navegador no soporta la reproducción de video.
          </video>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
